<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl
						? `master/product/${inputs.id}`
						: `master/product`
				"
			>
				<!-- <div class="form-group row align-items-center">
					<label for="inputs_product_category" class="col-sm-3 mb-0">
						{{ $t("product_category") }}
					</label>
					<app-input
						id="inputs_product_category"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_product_category"
						@input="setProductCategory"
						fetch-url="master/product-category"
						placeholder="Product Category"
						list-value-field="name"
						:required="true"
					/>
				</div> -->

				<div class="form-group row align-items-center">
					<label for="inputs_name" class="col-sm-3 mb-0">
						{{ $t("name") }}
					</label>
					<app-input
						id="inputs_name"
						class="col-sm-9"
						type="text"
						v-model="inputs.name"
						:placeholder="$t('name')"
						:required="true"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_description" class="col-sm-3 mb-0">
						{{ $t("description") }}
					</label>
					<app-input
						id="inputs_description"
						class="col-sm-9"
						type="text"
						v-model="inputs.description"
						:placeholder="$t('description')"
						:required="true"
					/>
				</div>
				<!-- Center ID -->
				<!-- <div class="form-group row align-items-center">
					<label for="inputs_center_id" class="col-sm-3 mb-0">
						{{ $t("center") }}
					</label>

					<app-input
						id="inputs_center"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_center"
						@input="setCenter"
						:fetch-url="`master/center?is_active=true`"
						:placeholder="this.$t('center')"
						list-value-field="name"
					/>
				</div> -->

				<!-- Price -->
				<div class="form-group row align-items-center">
					<label for="inputs_price" class="col-sm-3 mb-0">
						Price
					</label>
					<app-input
						id="inputs_price"
						class="col-sm-9"
						type="number"
						v-model="inputs.price"
						placeholder="Price"
						:required="true"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_start_date" class="col-sm-3 mb-0">
						Start Date
					</label>
					<app-input
						id="inputs_start_date"
						class="col-sm-9"
						type="date"
						v-model="inputs.start_date"
						placeholder="Start Date"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_end_date" class="col-sm-3 mb-0">
						End Date
					</label>
					<app-input
						id="inputs_end_date"
						class="col-sm-9"
						type="date"
						v-model="inputs.end_date"
						placeholder="End Date"
						:required="true"
					/>
				</div>
				<!-- <div class="form-group row align-items-center">
                    <label for="inputs_product_type" class="col-sm-3 mb-0">
                        {{ $t('product_type') }}
                    </label>
                    <app-input
                        id="inputs_product_type"
                        type="search-select"
                        class="col-sm-9"
                        :list="product_types"
                        :isAnimatedDropdown="true"
                        :placeholder="$t('product_type')"
                        v-model="inputs.product_type"
                        @input="setProductType"
                    />
                </div> -->

				<div
					class="form-group row align-items-center"
					v-if="!selectedUrl"
				>
					<label for="inputs_clc_id_number" class="col-sm-3 mb-0">
						CLC ID Number
					</label>
					<app-input
						id="inputs_clc_id_number"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_clc_id_number"
						@input="setClcIdNumber"
						:fetch-url="'transaction/lead?clc_id_number_operator=!=&clc_id_number=null'"
						placeholder="CLC ID Number"
						list-value-field="clc_id_number"
					/>
				</div>

				<!-- CLC ID Number -->
				<div
					class="form-group row align-items-center"
					v-if="selectedUrl && inputs.clc_id_number != null"
				>
					<label for="inputs_price" class="col-sm-3 mb-0">
						CLC ID Number
					</label>
					<app-input
						id="inputs_price"
						class="col-sm-9"
						type="text"
						v-model="read_only_clc_id_number"
						placeholder="CLC ID Number"
						disabled
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_is_active" class="col-sm-3 mb-0">
						&nbsp;
					</label>
					<div class="col-sm-8">
						<app-input
							id="inputs_is_active"
							:list-value-field="$t('is_active')"
							type="single-checkbox"
							v-model="inputs.is_active"
						/>
					</div>
				</div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";

export default {
	name: "ModalForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {
					product_category_id: undefined,
					code: "",
					name: "",
					is_active: "",
					product_category: {
						id: undefined,
						code: "",
						name: "",
						is_active: "",
					},
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			read_only_clc_id_number: this.inputs?.clc_id_number,
			// input_center: this.value
			// 	? this.value.center
			// 		? {
			// 				id: this.value.center.id || 0,
			// 				name: this.value.center.name || "",
			// 				is_active: this.value.center.is_active,
			// 		  }
			// 		: {
			// 				id: this.value.center?.id || 0,
			// 				name: this.value.center?.name || "",
			// 				is_active: this.value.center?.is_active,
			// 		  }
			// 	: {
			// 			id: this.value.center.id || 0,
			// 			name: this.value.center.name || "",
			// 			is_active: this.value.center.is_active,
			// 	  },
			input_product_category: this.value
				? this.value.product_category
					? {
							id: this.value.product_category.id || 0,
							name: this.value.product_category.name || "",
							code: this.value.product_category.code,
							is_active: this.value.product_category.is_active,
					  }
					: {
							id: this.value.product_category?.id || 0,
							name: this.value.product_category?.name || "",
							code: this.value.product_category?.code,
							is_active: this.value.product_category?.is_active,
					  }
				: {
						id: this.value.product_category.id || 0,
						name: this.value.product_category.name || "",
						code: this.value.product_category.code,
						is_active: this.value.product_category.is_active,
				  },
			input_clc_id_number: this.value
				? this.value.lead
					? {
							id: this.value.lead.id || 0,
							full_name: this.value.lead.full_name || "",
					  }
					: {
							id: this.value.lead?.id || 0,
							full_name: this.value.lead?.full_name || "",
					  }
				: {
						id: this.value.lead.id || 0,
						full_name: this.value.lead.full_name || "",
				  },
			product_types: [
				{
					id: 1,
					value: "Course",
				},
				{
					id: 2,
					value: "Charge",
				},
				{
					id: 3,
					value: "Deduction",
				},
			],
			inputs: {
				name: "",
				description: "",
				start_date: "",
				end_date: "",
			},
			modalId: this.formId,
			modalTitle: this.$t("add"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
		submit() {
			this.inputs.product_category_id = 3;

			if (this.selectedUrl) {
				this.inputs.created_at = this.formattedDate(
					this.inputs.created_at
				)
					? this.formattedDate(this.inputs.created_at)
					: this.formattedDate(new Date());
				this.inputs.updated_at = this.formattedDate(new Date());
				// this.inputs.center_id = this.input_center.id;
				this.inputs.created_by = this.inputs.created_by.id;
				this.inputs.updated_by = this.inputs.updated_by.id;
			}
			delete this.inputs.center_id;
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			this.inputs = response.data;
			this.inputs.price = this.inputs.price
				? this.inputs.price.toString().split(".")[0]
				: "";
			// this.input_center = {
			// 	id: this.inputs.center_id.id,
			// 	name: this.inputs.center_id.name,
			// 	is_active: this.inputs.center_id.is_active,
			// };
			this.read_only_clc_id_number = this.inputs.clc_id_number;
			this.preloader = false;
		},
		setProductCategory(data) {
			this.inputs.product_category_id = this.inputs.product_category_id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.product_category_id = data.id;
			}
		},
		setProductType(data) {
			this.inputs.product_type = this.inputs.product_type;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.product_type = data.id;
			}
		},
		// setCenter(data) {
		// 	this.inputs.center_id = this.inputs.center_id;
		// 	if (data && data.hasOwnProperty("id")) {
		// 		this.inputs.center_id = data.id;
		// 	}
		// },
		setClcIdNumber(data) {
			this.inputs.clc_id_number = this.inputs.clc_id_number;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.clc_id_number = data.clc_id_number;
			}
		},
		formattedDate(payloadDate) {
			const originalDate = payloadDate;
			const date = new Date(originalDate);

			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
			const day = date.getDate().toString().padStart(2, "0");

			const hour = date.getHours().toString().padStart(2, "0");
			const minute = date.getMinutes().toString().padStart(2, "0");
			const second = date.getSeconds().toString().padStart(2, "0");

			const formattedDate = `${year}-${month}-${day} ${hour}:${minute}:${second}`;

			return formattedDate;
		},
	},
};
</script>
